import { render, staticRenderFns } from "./BackupFilesModal.vue?vue&type=template&id=68441b14&"
import script from "./BackupFilesModal.vue?vue&type=script&lang=ts&"
export * from "./BackupFilesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports